module.exports = __webpack_public_path__ + "img/vol01_cup01_cover01.d89ba4b6.jpg";